import { render, staticRenderFns } from "./kv-checkbox.vue?vue&type=template&id=573c9d6a"
import script from "./kv-checkbox.vue?vue&type=script&lang=js"
export * from "./kv-checkbox.vue?vue&type=script&lang=js"
import style0 from "./kv-checkbox.vue?vue&type=style&index=0&id=573c9d6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports